import { useMutation } from '@tanstack/react-query';
import { IFlarelaneTag, patchFlarelaneUserTags } from '../../../api/flarelane/patchFlarelaneUserTags';
import { useGetUserProfile } from '../../user/useGetUserProfile';

export const usePatchFlarelaneUserTags = () => {
  const { userProfile } = useGetUserProfile();

  return useMutation((tags: IFlarelaneTag) => patchFlarelaneUserTags({ userId: userProfile?.id ?? '', tags }));
};
